import styled from '@emotion/styled';

export const UnderlinedText = styled('div')(() => ({
  textDecoration: 'underline blue',
  color: '#4c68d6',
}));
